module.exports = __webpack_public_path__ + "static/media/bgr-news-block003.f99c4ead.svg";